module.exports = __webpack_public_path__ + "static/media/IMG_3.9f53e466.jpg";